export default "__VITE_ASSET__MnR3D3BP__"